<!--
  图片支付二维码组件
-->
<!--<template>
  <div class="PicPayCode">

  </div>
</template>

<script>
export default {
  name: "PicPayCode"
}
</script>

<style scoped>

</style>-->


<!--/**
* @Author: wulizhou
* @Description: 支付码组件( 微信和支付宝 )
* @Date:
**/-->

<template>
  <div class="PicPayQrCode component">
    <no-ssr>
      <div class="payment-box">
        <div class="payment-item wx ">

          <div
            v-if="!isLogin"
            class="qr-code-nologin" @click="login">
            <span>立即登录</span>
          </div>

          <template v-else>

            <div class="certificate-txt qr-code" v-if="!isCertificate"
                 @click="codeCheckUserCertification">
              实名校验 <br>
              获取支付二维码
            </div>


            <template v-else>
              <div class="qr-scanner qr-code" v-if="paymentData.wxUrl == ''">
                <div class="box">
                  <div class="line"></div>
                  <div class="angle"></div>
                </div>
              </div>
              <div
                v-else
                class="qr-code">
                <img
                  class="qr-wft"
                  v-if="paymentData.isShowWft"
                  :src="paymentData.wxUrl"
                  alt="">
                <vue-qr
                  v-else
                  :text="paymentData.wxUrl"
                  :margin="0"
                  :logo-scale="0.3"
                  :size="200"
                />
              </div>
            </template>
          </template>

          <div class="icon-box">
            <i class="iconfont icon-wepay"/>
            微信支付
          </div>
        </div>
        <div class="payment-item zfb">
          <div
            v-if="!isLogin"
            class="qr-code-nologin" @click="login">
            <span>立即登录</span>
          </div>

          <template v-else>

            <div class="certificate-txt qr-code" v-if="!isCertificate"
                 @click="codeCheckUserCertification"
            >
              实名校验 <br>
              获取支付二维码
            </div>

            <template v-else>
              <div v-if="paymentData.zfbUrl == ''" class="qr-scanner qr-scanner-zfb">
                <div class="box">
                  <div class="line"></div>
                  <div class="angle"></div>
                </div>
              </div>

              <div
                class="qr-code qr-code-zfb">
                <vue-qr
                  :text="paymentData.zfbUrl"
                  :margin="0"
                  :logo-scale="0.3"
                  :size="200"
                />
              </div>
            </template>

          </template>


          <div class="icon-box">
            <i class="iconfont icon-alipay" style="color:#06B4FD;"/>
            支付宝支付
          </div>
        </div>
<!--        <div class="payment-item zfb jd _hide">-->
<!--          <div-->
<!--            v-if="!isLogin"-->
<!--            class="qr-code-nologin" @click="login">-->
<!--            <span>立即登录</span>-->
<!--          </div>-->

<!--          <template v-else>-->

<!--            <div class="certificate-txt qr-code" v-if="!isCertificate"-->
<!--                 @click="codeCheckUserCertification"-->
<!--            >-->
<!--              实名校验 <br>-->
<!--              获取支付二维码-->
<!--            </div>-->

<!--            <template v-else>-->
<!--              <div v-if="paymentData.jdUrl == ''" class="qr-scanner qr-scanner-zfb">-->
<!--                <div class="box">-->
<!--                  <div class="line"></div>-->
<!--                  <div class="angle"></div>-->
<!--                </div>-->
<!--              </div>-->

<!--              <div-->
<!--                class="qr-code qr-code-zfb">-->
<!--                <vue-qr-->
<!--                  :text="paymentData.jdUrl"-->
<!--                  :margin="0"-->
<!--                  :logo-scale="0.3"-->
<!--                  :size="200"-->
<!--                />-->
<!--              </div>-->
<!--            </template>-->

<!--          </template>-->


<!--          <div class="icon-box">-->
<!--            <i class="iconfont icon-jingdong" />-->
<!--            京东支付-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </no-ssr>

  </div>
</template>

<script>
/* 引入公共方法和常量 */
import * as fnCommon from '@/fn/_fn';
import * as CON_COMMON from '@/constant/_constant';

/* 引入组件 */
import vueQr from 'vue-qr'


/* 引入VUEX */
import {mapState} from "vuex";
import {fnLogin} from "@/fn";
import {getCookie} from "@/utils/auth";
import {setUserBindIphoneModalStatus} from "@/components/_Privately/User/UserBindIphoneModal/module";
import {
  codeCheckUserCertification,
  setCertificationModalStatus
} from "@/components/_Privately/User/UserCertificationModal/module";

/* 引入API */

export default {
  name: "PicPayQrCode"

  , components: {
    vueQr
  }

  , props: {
    paymentData: {
      type: Object,
      default: () => {
        return {
          isShowWft: false,
          zfbUrl: '',
          wxUrl: '',
        }
      }
    },
    isCertificate: true
  }

  , watch: {}

  , computed: {
    ...mapState('user',
      [
        'uid',
        'uniq_id',
        'isLogin'
      ]
    ),
  }


  , data() {
    return {}
  }

  , methods: {


    login() {
      if (!fnLogin.checkLogin()) {
        this.$store.commit('user/SET_IS_SHOW_LOGIN', true);
      }
    },
    codeCheckUserCertification() {
      codeCheckUserCertification();
    }
  }

}
</script>

<style lang="scss" scoped>
@import "components/pay/id/qr.scss";

.payment-box {
  display: flex;
  align-items: center;
  //justify-content: center;
  //padding: 40px 0 50px 210px;
  //box-sizing: border-box;
  //width: 100%;
  //padding: 0px 0 32px;
  justify-content: center;

  .payment-item {
    width: 140px;
    height: 140px;
    margin-right: 80px;
    position: relative;
    width: 170px;
    height: 170px;


    .qr-code-nologin {
      width: 170px;
      height: 170px;

      width: 170px;
      height: 170px;
      background-color: #eee;
      @include Position(1, 5, 0, 0);
      z-index: 10;
      line-height: 170px;
      text-align: center;
      color: #0A2540;
      text-decoration: underline;
      cursor: pointer;
      border-radius: 2px;

    }

    &:last-child {
      margin-right: 0;
    }

    .qr-code {
      //width: 120px;
      //height: 120px;
      height: 100%;
      flex-shrink: 0;
      width: 100%;
      padding: 3px;
      box-sizing: border-box;
      margin-bottom: 18px;
      position: relative;

      &:after{
        content: '';
        display: inline-block;
        width: 156px;
        height: 156px;
        width: 190px;
        height: 190px;
        border-radius: 8px;
        border: 2px solid #00AA74;
        box-sizing: border-box;
        @include Position(1,5,-10px,-10px);
        z-index: 5;
      }

      img {
        display: inline-block;
        width: 100%;

        &.qr-wft {
          position: absolute;
          //width: 120px;
          width: 170px;
          width: 203px;
          left: -15px;
          top: -15px;
        }
      }

      &.qr-code-zfb{
        &:after{
          border: 2px solid rgba(0, 167, 227, 1);
        }
      }
    }

    .icon-box {
      font-size: 13px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      z-index: 5;

      .iconfont {
        font-size: 16px;
        margin-right: 8px;

        &.icon-wepay {
          color: #00AA74;
        }

        &.icon-alipay {
          color: #00A7E3;
        }
      }
    }

    /* 微信 */
    &.wx {
      color: #00AA74;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;


      .icon-box {
        width: 148px;
        box-sizing: border-box;
      }
    }

    /* 支付宝 */
    &.zfb {
      color: #00A7E3;

      .qr-code{
        &:after{
          border: 2px solid rgba(0, 167, 227, 1);
        }
      }
    }

    &.jd {
      color: #E31D1A;

      .qr-code{
        &:after{
          border: 2px solid #E31D1A;
        }
      }
    }
  }

}

.certificate-txt {
  text-decoration: underline;
  text-align: center;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  z-index: 10;
}
</style>



